export var EventType;
(function (EventType) {
    EventType["ChannelCreated"] = "channel_created";
    EventType["NotificationResponse"] = "notification_response_received";
    EventType["PushReceived"] = "push_received";
    EventType["DeepLink"] = "deep_link_received";
    EventType["MessageCenterUpdated"] = "message_center_updated";
    EventType["PushNotificationStatusChangedStatus"] = "notification_status_changed";
    EventType["DisplayMessageCenter"] = "display_message_center";
    EventType["DisplayPreferenceCenter"] = "display_preference_center";
    EventType["PushTokenReceived"] = "push_token_received";
    EventType["IOSAuthorizedNotificationSettingsChanged"] = "ios_authorized_notification_settings_changed";
    EventType["IOSLiveActivitiesUpdated"] = "ios_live_activities_updated";
})(EventType || (EventType = {}));
//# sourceMappingURL=EventType.js.map